import "./ArModal.scss";

interface IProps {
  buttonText: string;
  onClick: () => void;
  title: string;
  instructions: string[];
  images?: string[];
}
const ArModal: React.FC<IProps> = ({
  buttonText,
  onClick,
  title,
  instructions,
  images,
}) => {
  return (
      <div className="helloar-ar-modal">
        <h4 className="helloar-ar-modal-title">{title}</h4>
        <section className="helloar-ar-modal-body">
          <ul>
            {instructions.map((instruction, index) => (
              <>
                <li>{instruction}</li>
                {images && images[index] && (
                  <img
                    className="helloar-instruction-img"
                    src={images[index]}
                    alt={`Instruction ${index + 1}`}
                  />
                )}
              </>
            ))}
          </ul>
        </section>
        <button className="helloar-ar-modal-button" onClick={onClick}>
          {buttonText}
        </button>
      </div>
  );
};

export default ArModal;
